module.exports = __webpack_public_path__ + "static/media/internet-dark-gray.dcbdb144.svg";